import WideContainer from '@r1-frontend/ui-react/components/layouts/wideContainer';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import { staticImagePath } from '~/src/features/mania/data';

import * as ST from './styled';

const HassleCare = (): JSX.Element => {
    return (
        <ST.HassleBlock>
            <WideContainer>
                <ST.HassleContent>
                    <ST.HassleTitle>Все хлопоты берём на себя</ST.HassleTitle>
                    <ST.HassleDesc>
                        Вы просто делитесь контактами ваших знакомых, а&nbsp;мы поможем подобрать тариф и ответим на все вопросы.
                    </ST.HassleDesc>
                </ST.HassleContent>
            </WideContainer>
            <ST.HassleImageBlock>
                <WebpImage urlWebp={`${staticImagePath}/hassle.webp`}>
                    <ST.HassleImage
                        src={`${staticImagePath}/hassle.jpg`}
                        alt='Улыбающаяся девушка сидит на кровати с ноутбуком и собакой'
                    />
                </WebpImage>
            </ST.HassleImageBlock>
        </ST.HassleBlock>
    );
};

export default HassleCare;
